
  <div class="scaOtp_wrapper text-center">

    <!-- OTP section-->
    <div class="otp_wrapper" *ngIf="authData.authType == 'OTP'">
      <div class="header-cls cp_black_semibold">{{title}}</div>
      <div class="inner_wrapper">
        <div class="cp-mt-12 cp_light_16_regular_label_black">{{"LIBRARY_COMPONENT.ENTER_OTP.SUB_HEADER" | translate}}
          <span class="cp_heading_2 d-block" *ngIf="mobileNo">{{mobileNo}}</span>
        </div>
        <form class="custom-form" [formGroup]="codeForm" (ngSubmit)="checkValidUser();" #lForm="ngForm" novalidate>
          <div class="cp-mt-32">
            <div class="d-flex justify-content-center ">
              <div class="pb-0 input_element" *ngFor="let input of formInput; index as i">
                <input tabindex="-1"
                [ngClass]="'input_'+i"
                type="tel" [class.disabled]="isTimeOutHappened || isOtpFailed" #otp #formRow formControlName="{{input}}"
                  [class.border-green]="!isOtpFailed" class="form-control cp-input" maxlength="1"
                   [numberOnly]="true" disableDragndrop
                  (input)="onOTPEnter($event, i, 'inputEvent')" (keyup)="onOTPEnter($event, i, 'keyUpEvent')" required
                  (keydown)="onOTPEnter($event, i, 'keydownEvent')" autocomplete="off">
              </div>
            </div>

            <div class="text-red-new" *ngIf="isOtpFailed">
              {{"LIBRARY_COMPONENT.ENTER_OTP.OTP_INCORRECT_ERROR" | translate}}
            </div>

            <div class="text-red-new" *ngIf="isTimeOutHappened">
              {{"LIBRARY_COMPONENT.ENTER_OTP.OTP_EXPIRED_ERROR" | translate}}
            </div>

          </div>

          <!-- <div class="resend_wrapper cp-mt-32" *ngIf="isTimeOutHappened || isOtpFailed">
              <a href="javascript:void(0);" class="cp-link" (click)="resendCode()"> Resend code</a>
          </div> -->

          <!-- <div [ngStyle]="{'visibility': !isTimeOutHappened ? 'visible' : 'hidden'}" class="row justify-content-center cp-mt-32">
            <span class="label">{{ 'CODE_VERIFY.DID_NOT_RECEIVE_CODE' | translate }}
              <a href="javascript:void(0);" class="cp-link" (click)="resendCode()">Resend</a>
            </span>
          </div> -->
          <div class="btn_wrapper flex" [ngClass]="(isTimeOutHappened || isOtpFailed)?'':'cp-mt-32'">
            <button type="button" (click)="(isTimeOutHappened || isOtpFailed)?resendCode() :closePopup()" class="cp-btn btn-block cp-btn-ternary">
              {{((isTimeOutHappened || isOtpFailed)?"LIBRARY_COMPONENT.ENTER_OTP.SEND_AGAIN_BUTTON" : "LIBRARY_COMPONENT.ENTER_OTP.CANCEL") | translate}}
            </button>

          </div>
        </form>


        <div class="timer cp_light_16_regular_label_black cp-mt-32 sub_title" *ngIf="!isTimeOutHappened && !isOtpFailed">
         {{"LIBRARY_COMPONENT.ENTER_OTP.EXPIRES_IN" | translate}} {{ Math.floor(counter / 60) | number: "2.0-0" }}:{{
            counter % 60 | number: "2.0-0"
          }}

        </div>
        <div
          *ngIf="!(isTimeOutHappened || isOtpFailed)"
          class="d-flex w-100 justify-content-center cp-mt-4"
        >
          <span class="cp_light_16_regular_label_black">
            {{ 'LIBRARY_COMPONENT.ENTER_OTP.DIDNT_RECEIVE' | translate }}
            <a
              href="javascript:void(0);"
              id="resendOtp"
              class="cp-link-black"
              (click)="resendCode()"
            >
              {{ 'LIBRARY_COMPONENT.ENTER_OTP.SEND_AGAIN_BUTTON' | translate }}
            </a>
          </span>
        </div>
      </div>

    </div>

    <!-- SCA section -->
    <div class="inner_wrapper" *ngIf="authData.authType == 'SCA'">
      <div class="cp-header ">{{title}}</div>

        <div class="cp-mt-12 cp-subheader sub_title">{{subTitle}}</div>

      <div class="cp-mt-20 auth_wrapper">
        <div class="authCode">
          <span class="authCodeText">{{authCode}}</span>
        </div>
      </div>

      <div class="text-red cp-mt-10" *ngIf="isTimeOutHappened">
        {{expired_message}}
      </div>

      <div class="timer cp-subheader sub_title cp-mt-48" *ngIf="!isTimeOutHappened">
        Code will be valid for 2 minutes

       </div>

       <div class="resend_wrapper cp-mt-24" *ngIf="isTimeOutHappened">
          <a href="javascript:void(0);" class="cp-link" (click)="resendCode()"> Generate new code</a>
      </div>

      <!-- <div class="error_wrapper" *ngIf="isTimeOutHappened">
        <div class="warning_indicator"></div>
        <div class="warning_text">{{expired_message}}</div>
        <div class="warning_link">
          <a class="cp-link" href="javascript:void(0);" (click)="resendCode()">Resend</a>
        </div>
      </div> -->
    </div>
    <!-- <div class="btn_wrapper flex cp-mt-36">
      <button type="button" (click)="closePopup()" class="cp-btn btn-block cp-btn-ternary">
        {{"LIBRARY_COMPONENT.CANCEL" | translate}}
      </button>
    </div> -->
  </div>
  <!--
    <div class="additional_wrapper">
      <div class="d-flex" *ngIf="additionalData?.PaymentsCount">
        <span class="flex-grow-1">Total payments</span>
        <span class="cp_heading_1">{{additionalData.PaymentsCount}}</span>
      </div>
    </div> -->
